/* Precision Cutworks quote form.
   - Works without JavaScript (native HTML validation and submission).
   - With JavaScript: accessible error summary, conditional trade fields,
     file list with validation, and upload submission to the quote service. */
(function () {
  'use strict';

  var form = document.querySelector('[data-quote-form]');
  if (!form) return;

  var mode = form.getAttribute('data-mode');
  var summary = form.querySelector('[data-error-summary]');
  var summaryList = form.querySelector('[data-error-list]');
  var statusEl = form.querySelector('[data-form-status]');
  var submitButton = form.querySelector('[data-submit]');
  var fileField = form.querySelector('[data-field="q-files"]');
  var fileInput = fileField ? fileField.querySelector('input[type="file"]') : null;
  var fileListEl = fileField ? fileField.querySelector('[data-file-list]') : null;
  var selectedFiles = [];
  var attempted = false;

  if (!summary) return; // Success state after a native submission.
  form.noValidate = true;

  var startedInput = form.querySelector('[data-form-started]');
  if (startedInput) startedInput.value = String(Date.now());

  /* Helpers ---------------------------------------------------------------- */
  function slug(text) {
    return String(text || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function formatBytes(bytes) {
    if (bytes < 1024 * 1024) return Math.max(1, Math.round(bytes / 1024)) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }
  function extension(name) {
    var match = /\.([a-z0-9]+)$/i.exec(name || '');
    return match ? '.' + match[1].toLowerCase() : '';
  }
  function radioValue(name) {
    var checked = form.querySelector('input[name="' + name + '"]:checked');
    return checked ? checked.value : '';
  }

  /* Prefill from the link that brought the visitor here --------------------- */
  var params = new URLSearchParams(window.location.search);
  var serviceSelect = form.querySelector('[data-service-select]');
  if (serviceSelect && params.get('service')) {
    var wanted = slug(params.get('service'));
    Array.prototype.forEach.call(serviceSelect.options, function (opt) {
      var s = slug(opt.value);
      if (opt.value && (s === wanted || s.indexOf(wanted) === 0 || wanted.indexOf(s) === 0)) serviceSelect.value = opt.value;
    });
  }
  if (params.get('type') === 'trade') {
    var tradeYes = form.querySelector('input[name="contact[Trade or repeat enquiry]"][value="Yes"]');
    var business = form.querySelector('input[name="contact[Customer type]"][value="Business"]');
    if (tradeYes) tradeYes.checked = true;
    if (business) business.checked = true;
    if (serviceSelect && !serviceSelect.value) {
      Array.prototype.forEach.call(serviceSelect.options, function (opt) { if (/trade/i.test(opt.value)) serviceSelect.value = opt.value; });
    }
  }
  var sourceInput = form.querySelector('[data-source-page]');
  if (sourceInput && document.referrer) {
    try {
      var ref = new URL(document.referrer);
      if (ref.origin === window.location.origin) sourceInput.value = ref.pathname;
    } catch (e) { /* ignore */ }
  }

  var dateInput = form.querySelector('[data-min-today]');
  if (dateInput) {
    var today = new Date();
    dateInput.min = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
  }

  /* Conditional trade fields --------------------------------------------- */
  var tradeFields = form.querySelector('[data-trade-fields]');
  function syncTrade() {
    if (!tradeFields) return;
    var show = radioValue('contact[Trade or repeat enquiry]') === 'Yes';
    tradeFields.hidden = !show;
    tradeFields.querySelectorAll('input, select, textarea').forEach(function (el) { el.disabled = !show; });
  }
  form.querySelectorAll('input[name="contact[Trade or repeat enquiry]"]').forEach(function (el) {
    el.addEventListener('change', syncTrade);
  });
  syncTrade();

  /* Files ------------------------------------------------------------------ */
  var maxFiles = fileField ? parseInt(fileField.getAttribute('data-max-files'), 10) || 5 : 0;
  var maxFileBytes = fileField ? (parseFloat(fileField.getAttribute('data-max-file-mb')) || 10) * 1024 * 1024 : 0;
  var maxTotalBytes = fileField ? (parseFloat(fileField.getAttribute('data-max-total-mb')) || 20) * 1024 * 1024 : 0;
  var allowed = fileField ? fileField.getAttribute('data-accept').split(',') : [];

  function fileProblem(file) {
    if (allowed.indexOf(extension(file.name)) === -1) return 'file type not accepted';
    if (file.size === 0) return 'file is empty';
    if (file.size > maxFileBytes) return 'larger than ' + formatBytes(maxFileBytes);
    return '';
  }

  function syncInputFiles() {
    if (!fileInput || typeof DataTransfer === 'undefined') return;
    try {
      var dt = new DataTransfer();
      selectedFiles.forEach(function (f) { dt.items.add(f); });
      fileInput.files = dt.files;
    } catch (e) { /* older browsers keep the native selection */ }
  }

  function renderFiles() {
    if (!fileListEl) return;
    fileListEl.innerHTML = '';
    selectedFiles.forEach(function (file, index) {
      var li = document.createElement('li');
      var problem = fileProblem(file);
      if (problem) li.className = 'is-invalid';
      var name = document.createElement('span');
      name.className = 'file-list__name';
      name.textContent = file.name;
      var size = document.createElement('span');
      size.className = 'file-list__size';
      size.textContent = problem ? problem : formatBytes(file.size);
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = 'Remove';
      remove.setAttribute('aria-label', 'Remove ' + file.name);
      remove.addEventListener('click', function () {
        selectedFiles.splice(index, 1);
        syncInputFiles();
        renderFiles();
        if (attempted) validate();
        fileInput.focus();
      });
      li.appendChild(name);
      li.appendChild(size);
      li.appendChild(remove);
      fileListEl.appendChild(li);
    });
  }

  if (fileInput) {
    var dropzone = fileField.querySelector('[data-dropzone]');
    fileInput.addEventListener('change', function () {
      Array.prototype.forEach.call(fileInput.files, function (file) {
        var duplicate = selectedFiles.some(function (f) { return f.name === file.name && f.size === file.size; });
        if (!duplicate) selectedFiles.push(file);
      });
      syncInputFiles();
      renderFiles();
      if (attempted) validate();
    });
    ['dragenter', 'dragover'].forEach(function (type) {
      fileInput.addEventListener(type, function () { dropzone.classList.add('is-dragover'); });
    });
    ['dragleave', 'drop'].forEach(function (type) {
      fileInput.addEventListener(type, function () { dropzone.classList.remove('is-dragover'); });
    });
  }

  /* Validation ------------------------------------------------------------- */
  function setError(fieldId, message) {
    var wrapper = form.querySelector('[data-field="' + fieldId + '"]');
    var errorEl = document.getElementById(fieldId + '-error');
    if (!wrapper || !errorEl) return;
    var isGroup = wrapper.tagName === 'FIELDSET';
    wrapper.classList.toggle(isGroup ? 'choice-group--error' : 'field--error', !!message);
    errorEl.hidden = !message;
    errorEl.textContent = message ? message : '';
    var controls = wrapper.querySelectorAll('input, select, textarea');
    controls.forEach(function (c) {
      if (c.type === 'hidden') return;
      if (message) c.setAttribute('aria-invalid', 'true'); else c.removeAttribute('aria-invalid');
    });
  }

  function validate() {
    var errors = [];
    function check(fieldId, message) {
      setError(fieldId, message);
      if (message) errors.push({ id: fieldId, message: message });
    }
    var val = function (id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; };

    check('q-name', val('q-name') ? '' : 'Enter your full name');

    var email = val('q-email');
    check('q-email', !email ? 'Enter your email address' : (/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email) ? '' : 'Enter an email address in the correct format, like name@example.co.uk'));

    var phone = val('q-phone');
    check('q-phone', phone && !/^[0-9+()\s.-]{6,40}$/.test(phone) ? 'Enter a valid telephone number, or leave it blank' : '');

    check('q-customer-type', radioValue('contact[Customer type]') ? '' : 'Select whether you are enquiring as a business or an individual');
    check('q-service', val('q-service') ? '' : 'Choose the service you need');

    var qty = val('q-quantity');
    var qtyNum = Number(qty);
    check('q-quantity', !qty ? 'Enter the quantity you need' : (Number.isInteger(qtyNum) && qtyNum >= 1 ? '' : 'Quantity must be a whole number of 1 or more'));

    ['q-width', 'q-height'].forEach(function (id) {
      var v = val(id);
      check(id, v && !(Number(v) > 0) ? 'Enter a size in millimetres greater than 0' : '');
    });

    var dateVal = val('q-date');
    if (dateInput && dateVal && dateInput.min && dateVal < dateInput.min) check('q-date', 'The required date must be today or in the future');
    else check('q-date', '');

    var postcode = val('q-postcode');
    check('q-postcode', postcode && !/^[A-Z]{1,2}[0-9][A-Z0-9]?\s*[0-9][A-Z]{2}$/i.test(postcode) ? 'Enter a full UK postcode, like S40 1AA' : '');

    check('q-body', val('q-body') ? '' : 'Describe your project so we can prepare an accurate quote');

    if (fileField) {
      var message = '';
      var total = selectedFiles.reduce(function (sum, f) { return sum + f.size; }, 0);
      var bad = selectedFiles.filter(function (f) { return fileProblem(f); });
      if (selectedFiles.length > maxFiles) message = 'Upload up to ' + maxFiles + ' files. Remove ' + (selectedFiles.length - maxFiles) + ' to continue';
      else if (bad.length) message = 'Remove or replace ' + bad.map(function (f) { return f.name; }).join(', ') + ': ' + fileProblem(bad[0]);
      else if (total > maxTotalBytes) message = 'Your files total ' + formatBytes(total) + '. The limit is ' + formatBytes(maxTotalBytes) + '. Remove a file or email large files separately';
      check('q-files', message);
    }

    var turnstile = form.querySelector('.cf-turnstile');
    if (turnstile) {
      var token = form.querySelector('[name="cf-turnstile-response"]');
      check('q-turnstile', token && token.value ? '' : 'Please complete the spam check');
    }
    return errors;
  }

  function showSummary(errors) {
    summaryList.innerHTML = '';
    errors.forEach(function (err) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      var wrapper = form.querySelector('[data-field="' + err.id + '"]');
      var target = wrapper ? wrapper.querySelector('input:not([type="hidden"]), select, textarea') : null;
      a.href = '#' + (target ? target.id : err.id);
      a.textContent = err.message;
      a.addEventListener('click', function (event) {
        event.preventDefault();
        if (target) {
          target.focus();
          (wrapper || target).scrollIntoView({ block: 'center' });
        }
      });
      li.appendChild(a);
      summaryList.appendChild(li);
    });
    summary.hidden = errors.length === 0;
    if (errors.length) summary.focus();
  }

  window.addEventListener('pageshow', function () { setBusy(false); });
  form.addEventListener('input', function () { if (attempted) validate(); });
  form.addEventListener('change', function () { if (attempted) validate(); });

  /* Submission ------------------------------------------------------------- */
  function setBusy(busy) {
    if (!submitButton) return;
    submitButton.setAttribute('aria-busy', busy ? 'true' : 'false');
    submitButton.disabled = busy;
    if (statusEl) statusEl.textContent = busy ? 'Sending your quote request…' : '';
  }

  function showServerError(message) {
    showSummary([{ id: 'q-body', message: message }]);
  }

  form.addEventListener('submit', function (event) {
    attempted = true;
    var errors = validate();
    var honeypot = form.querySelector('[name="hp_website"]');

    if (errors.length) {
      event.preventDefault();
      showSummary(errors);
      return;
    }
    summary.hidden = true;

    if (honeypot && honeypot.value) {
      // Likely automated: quietly do nothing.
      event.preventDefault();
      return;
    }

    if (mode !== 'upload' || !window.fetch || !window.FormData) {
      setBusy(true);
      return; // Native submission.
    }

    event.preventDefault();
    setBusy(true);
    var data = new FormData(form);
    data.delete('files');
    selectedFiles.forEach(function (file) { data.append('files', file, file.name); });

    fetch(form.action, { method: 'POST', body: data, headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) { return { ok: response.ok, status: response.status, body: body }; });
      })
      .then(function (result) {
        if (result.ok && result.body && result.body.ok) {
          var successUrl = form.getAttribute('data-success-url') || '/pages/quote-received';
          var reference = result.body.reference ? '?ref=' + encodeURIComponent(result.body.reference) : '';
          window.location.assign(successUrl + reference);
          return;
        }
        setBusy(false);
        var fieldErrors = result.body && result.body.errors;
        if (fieldErrors && fieldErrors.length) {
          var mapped = fieldErrors.map(function (e) { return { id: e.field || 'q-body', message: e.message }; });
          mapped.forEach(function (e) { setError(e.id, e.message); });
          showSummary(mapped);
        } else if (result.status === 413) {
          showServerError('Your files are too large to send. Remove a file or email large files to us separately.');
        } else {
          showServerError((result.body && result.body.message) || 'Sorry, your request could not be sent. Please try again, or email us your project details.');
        }
        if (window.turnstile && form.querySelector('.cf-turnstile')) window.turnstile.reset();
      })
      .catch(function () {
        setBusy(false);
        showServerError('We could not connect to send your request. Check your connection and try again, or email us your project details.');
      });
  });
})();
